module.exports = __webpack_public_path__ + "static/telecommunication_icon-78b9a2f483b9a5e430fa85272046d79f.svg";